import { SelectedSystemType } from 'data/types';
import { QuotedSystemSnapshotType } from 'utils/quoted-system-snapshot-types';

export function selectedSystemFromQuotedSnapshot(
  snapshot: QuotedSystemSnapshotType
): SelectedSystemType {
  return {
    ...snapshot,
    inStock: snapshot.inStock ?? false,
    restockDate: snapshot.restockDate ?? null
  };
}
